import { render, staticRenderFns } from "./RobberyHouseSecuredYesNoQuestion.vue?vue&type=template&id=3fb74cd8&scoped=true"
import script from "./RobberyHouseSecuredYesNoQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyHouseSecuredYesNoQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyHouseSecuredYesNoQuestion.vue?vue&type=style&index=0&id=3fb74cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb74cd8",
  null
  
)

export default component.exports